'use client'

import clsx from 'classnames'
import { useLocale } from 'use-intl'
import { HTMLProps } from 'react'
import { Text } from '@/shared/ui'
import BricsLogo from '@/shared/icons/logo-small.svg'
import BricsLogoEng from '@/public/logo-small-eng.svg'
import { TagLink } from '@/shared/ui/tag-link'
import { IGlobals, ISocial } from '@/interfaces/common'
import Hse from '@/public/hse.svg'
import HseEng from '@/public/hse-eng.svg'
import style from './footer.module.scss'

interface FooterProps extends HTMLProps<HTMLDivElement> {
  socials: ISocial[]
  globals: IGlobals | null
}

export const Footer = (props: FooterProps) => {
  const { className, socials, globals } = props
  const classNames = clsx(className, style.footer, 'main-padding')
  const currentLocale = useLocale()

  return (
    <footer id="contacts" className={classNames}>
      <Text className={style.address} tagName="h2" type="l1" isAppearance __html={globals?.contacts ?? ''} />
      {currentLocale === 'ru' ? <BricsLogo className={style.logo} /> : <BricsLogoEng className={style.logo} />}
      {currentLocale === 'ru' ? <Hse className={style.hse} /> : <HseEng className={style.hse} />}
      <Text className={style.copyright} tagName="p" type="d" isAppearance>
        © {new Date().getFullYear()} {globals?.copyright ?? ''}
      </Text>
      <ul className={style.socialList}>
        {socials.map(({ name, url, color }) => {
          return <TagLink key={name} name={name} href={url} color={color} />
        })}
      </ul>
    </footer>
  )
}
